module.exports = ""


//////////////////
// WEBPACK FOOTER
// F:/Projects/anoki/src/app/layout/header/header.component.html
// module id = ../../../../../src/app/layout/header/header.component.html
// module chunks = main